// Allowed MIME types for customer document uploads.
// Must mirror the bucket's allowed_mime_types in 16-storage.sql — keep these in sync.
export const ALLOWED_MIME_TYPES = new Set([
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]);
